<template>
  <nav class="Navbar" :mobile-active="this.$store.state.responsiveMenu">
    <div class="Navbar__left">
        <IconButton
          icon="close"
          id="menu_close"
          v-on:clicked="toggleResponsiveMenu"
          :is-triggerable="true"
          :data-active="this.$store.state.iframe"
          :data-no-bg="true"
          :active="this.$store.state.iframe"
          />
      <h3 class="Mobile__title show-sm">{{ words[lang].mobile.SelectMap }}</h3>
      <div :class="'Navbar__item' + (i.key === activeNavbarItem ? ' Navbar__item--active' : '')"
          v-for="i in navbarItems"
          v-on:click="updateNavbarItem(i.key)"
          :key="i.key"
          >{{ i.label }}</div>
      <h3 class="Mobile__title show-sm">{{ words[lang].mobile.Language }}</h3>
      <Translator
        className="show-sm"
        />
    </div>
    <SharingModal/>
    <div class="Navbar__right">
      <IconButton
        :hint="words[lang].share.ShareThisMap"
        icon="share"
        id="share"
        v-on:clicked="toggleSharing"
        :is-triggerable="true"
        :data-active="this.$store.state.sharing"
        :data-no-bg="true"
        :active="this.$store.state.sharing"
        />
      <IconButton
        :hint="words[lang].hint.ShowMapInFullscreen"
        :hint-message="words[lang].hint.MessageShowMapInFullscreen"
        icon="fullscreen"
        id="fullscreen"
        icon-triggered="fullscreen_exit"
        v-on:clicked="toggleFullscreen"
        :is-triggerable="true"
        :data-active="this.$store.state.fullscreen"
        :data-no-bg="true"
        :active="this.$store.state.fullscreen"
        :show-hint="this.$store.state.hoverFirstState"
        />
      <IconButton
        :hint="words[lang].hint.TogglePanel"
        icon="close"
        v-on:clicked="toggleSidebar"
        :is-triggerable="true"
        :data-active="this.$store.state.infoPanelDeployed"
        :active="this.$store.state.infoPanelDeployed"
        id="toggle"
        />
    </div>
  </nav>
</template>

<script>

import IconButton from './IconButton.vue'
import Translator from './Translator.vue'
import SharingModal from './SharingModal.vue'
import { words } from '@/constants/lang'

export default {
  name: 'Navbar',
  components: { IconButton, Translator, SharingModal },
  data: () => ({
    words
  }),
  watch: {
    '$store.state.hoverFirstState': function() {
      // Show hint when user close info legend panel, so that he knows where the button to show it again is.
      if (this.$store.state.hoverFirstState) {
        let self = this;
        setTimeout(function () {
          self.showHint = false
        }, 5000)
      }
    }
  },
  computed: {
    activeNavbarItem: function () {
      return this.$store.state.activeNavbarItem
    },
    navbarItems: function () {
      return [
        { key: 'status', label: words[this.$store.state.language.lang].navbar.Status },
        { key: 'treaty', label: words[this.$store.state.language.lang].navbar.Treaty }
      ]
    },
    lang: function () {
      return this.$store.state.language.lang
    }
  },
  methods: {
    toggleResponsiveMenu: function () {
      this.$store.commit('toggleResponsiveMenu')
    },
    toggleSidebar: function () {
      let self = this;
      this.$store.commit('toggleInfoPanel')
      setTimeout(function() {self.$store.commit('updateActiveCountry', null)}, 350)
    },
    updateNavbarItem(navbarItem) {
      this.$store.commit('updateActiveNavbarItem', navbarItem)
      let self = this;
      setTimeout(function () {self.$store.commit('toggleResponsiveMenu', false)}, 0);

     // Opens automatically legend info if first time
      if (navbarItem === "treaty" && this.$store.state.moreInfoTreaty === false) {
        self.$store.commit('updateActiveCountry', null)
        this.$store.commit('updateMoreInfoTreaty')
        this.$store.commit('toggleInfoPanel', true)
      } else if (navbarItem === "status" && this.$store.state.moreInfoStatus === false) {
        self.$store.commit('updateActiveCountry', null)
        this.$store.commit('updateMoreInfoStatus')
        this.$store.commit('toggleInfoPanel', true)
      }
    },
    toggleFullscreen: function () {
      this.$store.commit('toggleFullscreen')
    },
    toggleSharing: function () {
      this.$store.commit('toggleSharing')
    }
  }
}
</script>

<style lang="less">

@import "../less/_var.less";

#fullscreen[show-hint] {
  border: solid 2px @color-primary;
  box-sizing: border-box;
  transition: all .2s ease-in;
  &::before {
    transition: content .01ms .21s linear;
    content: attr(hint-message);
    border-top-right-radius: 0;
    background: rgba(0,0,0,1);
    color: white;
    font-weight: 100 !important;
  }
}

.Navbar {
  width: 100%;
  height: @dim-navbar;
  // background: white;
  // color: @color-primary;
  background: @color-primary;
  color: #ddd;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  z-index: 6;
  position: relative;
  box-shadow: 0 3px 15px rgba(0,0,0,0.4);

  .Iframe__toggler {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;

    .IframeSharing {
      transform: translateY(0);
      opacity: 1;
      transition: opacity .2s ease-in;
    }

    .IframeSharing:not([data-active]) {
      transform: translateY(-200px);
      opacity: 0;
    }
  }

  .Navbar__left {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 100%;

    .Navbar__item {
      padding: 0 20px;
      font-size: @font-sm - 0.1em;
      text-transform: uppercase;
      height: 100%;
      font-family: @font-secondary;
      font-weight: 100;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      position: relative;
      cursor: pointer;
      color: white;

      &:not(&--active) {
        border-right: solid 1px fade(white, 50%);
      }

      &--active {
        // @color-active-item-bg: @color-primary;
        // color: white;
        @color-active-item-bg: white;
        color: @color-primary;

        background: @color-active-item-bg;

        &::after {
          content: "";
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 22px 12px 0;
          border-color: transparent @color-active-item-bg transparent transparent;
          position: absolute;
          top: 100%;
          right: 0;
          margin: auto;
        }
      }
    }
  }

  .Navbar__right {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 100%;

    .IconButton[is-triggerable] {
      cursor: pointer;
      border-radius: 0;
      height: 100%;
      width: 40px;
      min-width: 40px;
      background: none;

      &#fullscreen .IconButton__icon {
        width: 24px;
      }

      &::before {
        top: 50px;
        right: 10px;
      }

      &[data-active]:not(#ecpmToggle):not([data-no-bg]) {
        background: #cdcdcd;
      }

      &[data-active=true] {
        &#toggle {
          width: 40px;
          min-width: 40px;
          opacity: 1;
        }

        &#ecpmToggle {
          .IconButton__icon {
            opacity: 1;
          }
        }
      }

      &:not([data-active]) {
        &#ecpmToggle {
          .IconButton__icon {
            opacity: 0.7;
          }
        }
      }

      &#toggle {
        width: 0px;
        min-width: 0;
        background: #cdcdcd !important;
        opacity: 0;
      }
    }
  }

  #menu_close {
    margin-bottom: 30px;
    visibility: hidden;
    display: none;
    transform: translateY(-8px);
  }
}

@media screen and (max-width: 350px) {
  #app .TitleCtn .TitleCtn__desktop  {
    #menu {
      margin: 0 5px 0 13px !important;
    }
    h1 {
      font-size: 1.35em !important;
    }
  }
}

@media screen and (max-width: 640px) {
  .Navbar {
    position: fixed;
    background: white;
    color: black !important;
    top: 0;
    left: 0;
    height: calc(100% - 30px);
    width: calc(100% - 30px);
    padding: 15px;
    flex-flow: column nowrap;
    z-index: 6;
    clip-path: circle(0px at 40px 40px);
    transition: clip-path 0.6s ease-out, transform 0.01ms 0.6s linear;
    transform: translateY(-9999px);

    .Mobile__title {
      text-transform: uppercase;
      color: #878787;
      text-align: center;
      width: 100%;
      font-size: 0.9em;
      font-weight: 100;
      display: inline-block;
    }

    #menu_close {
      display: inherit;

      .IconButton__icon {
        width: 22px;
      }
    }

    .Translator {
      height: auto;
      margin: 0 auto;
    }

    &[mobile-active=true] {
      clip-path: circle(1600px at 40px 40px);
      transform: translateY(0);
      transition: clip-path 0.6s 0.02ms ease-in, transform 0.01ms linear;

      #menu_close {
        visibility: visible;
      }
    }

    .Navbar__right {
      display: none;
    }

    .Navbar__left {
      flex-flow: column;
      width: 100%;
      align-items: flex-start;

      .Navbar__item {
        padding: 0;
        min-height: 60px;
        height: 60px;
        border-radius: 8px;
        background-color: white;
        color: black;
        box-shadow: 0 2px 10px -2px rgba(0,0,0,0.2);
        border: none;
        font-weight: 400;
        width: calc(100% - 20px);
        margin: 0 10px 15px 10px;
        text-align: center;
        justify-content: center;

        &::after { content: none; }

        &--active {
          background: @color-primary;
          color: white;
        }
      }
    }
  }
}
</style>
